// export const handleUppercaseChange = (
//     e,
//     handleChange
// ) => {
    

//     e.target.value = e.target.value
//         .toLowerCase()
//         .replace(/\b\w/g, (char) => char.toUpperCase());
//     handleChange(e);
// };
export const handleUppercaseChange = (e, handleChange) => {
    e.target.value = e.target.value.toUpperCase();
    handleChange(e);
};
